/* eslint-disable valid-typeof */
import { FileApi, FileDto } from "generated/apiFiles";
import { Configuration } from "generated/configuration";
import { getLoggedinUser } from "helpers/api_helper";

const { REACT_APP_API_URL } = process.env;

export const createFile = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new FileApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
      baseOptions: {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 600000, // 10 minuti per upload file grandi
      },
    })
  );
  return api.fileControllerCreate(data);
};


export const createFolder = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new FileApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.fileControllerCreateFolder(data);
};

export const requestSyncFiles = async () => {
  const authUser: any = getLoggedinUser();
  const api = new FileApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.fileControllerRequestSyncFiles();
};

export const syncFiles = async () => {
  const authUser: any = getLoggedinUser();
  const api = new FileApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.fileControllerSyncFiles();
};


export const deleteBulkFile = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new FileApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.fileControllerDelete(data);
};


export const deleteKnowledgeBase = async () => {
  const authUser: any = getLoggedinUser();
  const api = new FileApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.fileControllerDeleteKnowledgeBase();
};


export const downloadFile = async (data: FileDto) => {
  const authUser: any = getLoggedinUser();
  const api = new FileApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
      baseOptions: {
        headers: {
          Accept: "application/octet-stream",
        },
        responseType: "blob",
      },
    })
  );

  const response = await api.fileControllerDownloadFile(data.id);

  const blobUrl: string = window.URL.createObjectURL(
    response.data as unknown as Blob
  );
  const downloadLink: HTMLAnchorElement = document.createElement("a");
  downloadLink.href = blobUrl;
  downloadLink.setAttribute("download", data.title || "downloaded_file");

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  window.URL.revokeObjectURL(blobUrl);
  return response;
};
